import base from '../dr-base'
import drIcon from './dr-icon.vue'

const schema = {
  $Type: 'dr-icon',
  name: 'Icon',
  group: 'Common widgets',
  icon: 'icons',
  ...base,
  properties: {
    ...base.properties,
    Color: {
      name: 'vuetifyWidgets.dr-icon.color',
      type: 'string',
      component: 'dr-color-picker'
    },
    Icon: {
      name: 'vuetifyWidgets.dr-icon.icon',
      type: 'string',
      default: 'mdi-image',
      component: 'dr-icon-picker'
    }
  }
}

export default {
  schema,
  component: drIcon,
  propEditors: [
    {
      name: 'dr-icon-picker'
    },
    {
      name: 'dr-color-picker'
    }
  ]
}
  